<template>
  <div>
    <el-card class="page-container">
      <el-row>
        <el-row class="search"
          ><span>机器人rid：</span>
          <el-input
            type="text"
            v-model="search.ridStr"
            placeholder="请输入机器人rid"
            clearable
          ></el-input>
          <span> 名字：</span
          ><el-input
            type="text"
            v-model="search.name"
            placeholder="请输入机器人rid"
            clearable
          ></el-input>
          <span> 国家：</span>
          <el-select
            v-model="search.countryCode"
            placeholder="请选择国家"
            clearable=""
            filterable=""
          >
            <el-option
              v-for="(item, itemIndex) in countryList"
              v-bind:key="itemIndex + 99"
              :label="item.country"
              :value="item.countryCode"
            ></el-option>
          </el-select>
          <span> 状态 ：</span>
          <el-select
            v-model="search.state"
            placeholder="请选择状态 "
            clearable=""
            filterable=""
          >
            <el-option
              v-for="(item, itemIndex) in statusList"
              v-bind:key="itemIndex + 99"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
          <span>时间范围：</span>
          <el-date-picker
            v-model="datetime"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="retainedOptions"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          <el-button type="primary" @click="query" :loading="loading"> 查询 </el-button>
          <el-upload
            class="upload-demo"
            :limit="1"
            action
            :on-change="uploadFile1"
            ref="upload"
          >
            <el-button type="danger" :loading="uploadFile">上传</el-button>
          </el-upload>
        </el-row>
        <el-row>
          <el-table
            :data="datalist"
            style="width: 100%"
            v-loading="loading"
            height="60vh"
            stripe
            border
          >
            <el-table-column prop="rid" label="rid "> </el-table-column>
            <el-table-column prop="uid" label="uid "> </el-table-column>
            <el-table-column prop="originUid" label="机器人信息来源uid ">
            </el-table-column>
            <el-table-column prop="originRid" label="机器人信息来源rid ">
            </el-table-column>
            <el-table-column prop="name" label="名字 "> </el-table-column>
            <el-table-column prop="country" label="国家 "> </el-table-column>
            <el-table-column prop="countryCode" label="国家码 "> </el-table-column>
            <el-table-column label="头像">
              <template slot-scope="scope">
                <el-image
                  v-if="scope.row.head != ''"
                  style="width: 100px; height: 100px"
                  :src="scope.row.head"
                  :preview-src-list="[scope.row.head]"
                ></el-image>
              </template>
            </el-table-column>
            <el-table-column prop="age" label="年龄"> </el-table-column>
            <el-table-column prop="langId" label="语言">
              <template slot-scope="scope">
                {{
                  languageList.filter((item) => item.langCode == scope.row.langId)[0] &&
                  languageList.filter((item) => item.langCode == scope.row.langId)[0]
                    .language
                }}
              </template>
            </el-table-column>
            <el-table-column prop="signature" label="个人简介"> </el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                {{ statusList[scope.row.state].name }}
              </template>
            </el-table-column>
            <el-table-column prop="genSign" label="生成标记"> </el-table-column>
            <el-table-column prop="ctime" label="创建时间"> </el-table-column>
            <el-table-column prop="operator" label="操作人"> </el-table-column>
            <el-table-column prop="mtime" label="操作时间"> </el-table-column>

            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="warning" size="mini" @click="operate(1, scope.row)"
                  >修改</el-button
                >
                <el-button type="danger" size="mini" @click="operate(3, scope.row.uid)"
                  >删除</el-button
                >
              </template></el-table-column
            >
          </el-table>
        </el-row>
        <el-row>
          <el-pagination
            :current-page.sync="search.page"
            layout="total, prev, pager, next"
            background
            @current-change="handleCurrentChange"
            :total="search.total"
            class="pagination"
            :page-size="10"
          ></el-pagination>
        </el-row>
      </el-row>
      <el-dialog
        append-to-body
        title="修改"
        :visible.sync="dialog"
        :before-close="cancel"
        width="50%"
      >
        <div class="item">
          <div>
            <span>名字：</span>
            <el-input v-model="form.name" type="text" />
          </div>
          <div>
            <span>国家：</span>
            <el-select filterable v-model="form.countryCode" clearable placeholder="">
              <el-option
                v-for="(item, itemIndex) in countryList"
                v-bind:key="itemIndex + 99"
                :label="item.country"
                :value="item.countryCode"
              ></el-option>
            </el-select>
          </div>
          <div>
            <span>头像：</span>
            <el-upload
              class="avatar-uploader"
              action=""
              :auto-upload="false"
              :show-file-list="false"
              :on-change="changfile"
              ref="upload"
            >
              <el-image
                v-if="form.head !== ''"
                style="width: 178px; height: 178px"
                :src="form.head"
                fit="scale-down"
              ></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div>
            <span>年龄：</span>
            <el-input v-model="form.age" type="number" />
          </div>
          <div>
            <span>语言ID：</span>
            <el-select filterable v-model="form.langId" clearable placeholder="">
              <el-option
                v-for="(item, itemIndex) in languageList.slice(3)"
                v-bind:key="itemIndex + 99"
                :label="item.language"
                :value="item.langCode"
              ></el-option>
            </el-select>
          </div>
          <div>
            <span>个人简介：</span>
            <el-input v-model="form.signature" type="textarea" />
          </div>
          <div>
            <span>状态：</span>
            <el-select filterable v-model="form.state" clearable placeholder="">
              <el-option
                v-for="(item, itemIndex) in statusList.slice(1)"
                v-bind:key="itemIndex + 99"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button :loading="upload" type="primary" @click="operate(2)"
            >修 改</el-button
          >
          <el-button @click="cancel">取 消</el-button>
        </div>
      </el-dialog>
    </el-card>
    <robotAvatarManagement />
  </div>
</template>

<script>
import { getCountryMore, getLanguage } from "@/utils/normalApi.js";
import { datainfor } from "@/utils/formdata.js";
import robotAvatarManagement from "./robotAvatarManagement.vue";
export default {
  name: "robot",
  components: {
    robotAvatarManagement,
  },
  data() {
    return {
      loading: false,
      upload: false,
      uploadFile: false,
      dialog: false,
      form: {},
      countryList: [],
      languageList: [],
      statusList: [],
      datalist: [],
      datetime: [datainfor(8), datainfor(0)],
      retainedOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      search: {
        ridStr: null,
        name: null,
        countryCode: null,
        state: null,
        page: 1,
        total: 0,
      },
    };
  },
  created() {
    this._getLanguage();
    this._getCountry();
    this.getRobotStatus();
    this.query();
  },
  methods: {
    async query() {
      this.loading = true;
      const { data: res } = await this.$axios({
        method: "get",
        url:
          this.$store.getters.path.robot_query +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token,
        withCredentials: true,
        params: {
          ...this.search,
          startTimeStr: this.datetime[0],
          endTimeStr: this.datetime[1],
        },
      });
      this.loading = false;
      if (res.code != 0) return this.$message.error(res.msg);
      this.datalist = res.data.data;
      this.search.total = res.data.total;
      this.$message.success("查询成功");
    },
    handleCurrentChange(num) {
      this.search.page = num;
      this.query();
    },
    async changfile(file) {
      this.upload = true;
      const formdata = new FormData();
      formdata.append("file", file.raw);
      formdata.append("cover", 0);
      formdata.append("dir", `Head/${this.form.uid}`);
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token,
        formdata
      );
      this.upload = false;
      if (res.code !== 0) {
        this.$refs.upload.clearFiles();
        return this.$message.error("文件上传失败请重新选择文件上传");
      }
      this.form.head = res.data;
    },
    async operate(type, obj) {
      if (type === 1) {
        this.dialog = true;
        this.form = { ...obj };
      } else if (type === 2) {
        const { data: res } = await this.$axios.post(
          this.$store.getters.path.robot_update +
            "?username=" +
            this.$store.getters.username +
            "&token=" +
            this.$store.getters.token,
          this.form
        );
        if (res.code != 0) return this.$message(res.msg);
        this.$message.success("操作成功");
        this.cancel();
        this.query();
      } else if (type === 3) {
        this.$confirm("确认删除此项配置", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          const { data: res } = await this.$axios(
            this.$store.getters.path.robot_del +
              "?username=" +
              this.$store.getters.username +
              "&token=" +
              this.$store.getters.token +
              "&uid=" +
              obj,
            {}
          );
          if (res.code !== 0) return this.$message.error("删除失败");
          this.$message.success("删除成功");
          this.query();
        });
      }
    },
    cancel() {
      this.form = {};
      this.dialog = false;
    },
    async _getLanguage() {
      const res = await getLanguage();
      if (res !== null) this.languageList = res;
    },
    async _getCountry() {
      const res = await getCountryMore();
      if (res !== null) this.countryList = res.countryList;
    },
    async getRobotStatus() {
      const { data: res } = await this.$axios({
        method: "get",
        url:
          this.$store.getters.path.robot_status +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token,
      });
      if (res.code != 0) this.$message(res.msg);
      this.statusList = res.data;
    },
    async uploadFile1(file) {
      if (this.uploadFile) return;
      this.uploadFile = true;
      const formdata = new FormData();
      formdata.append("file", file.raw);
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.robot_upload +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token,
        formdata
      );
      this.uploadFile = false;
      this.$refs.upload.clearFiles();
      if (res.code != 0) return this.$message(res.msg);
      this.$message.success("上传成功");
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  > * {
    margin: 3px;
  }
}

.el-textarea,
.el-input {
  width: 300px;
}
.item > div {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  border-bottom: 1px solid #efefef;
  padding: 20px 0;
  > * {
    margin: 3px;
  }
}
</style>
